import { Subject } from "rxjs";

const UserSummarySubject = new Subject();

const UserSummaryService = {
  listen: () => UserSummarySubject.asObservable(),
  fetchUserSummaryData: () => UserSummarySubject.next()
};

export default UserSummaryService;